/* This page is for Approval and Display page */

import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector /* useDispatch */ } from "react-redux";

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
import ShowHorizontalStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowHorizontalStatus";
import EvaluationTable from "../../../../Components/PivotTable/EvaluationTable";
import TechnoCommercialComparison from "../../../../Components/PivotTable/TechnoCommercialComparison";
import CommLineItemTable from "../../../../Components/PivotTable/CommLineItemTable";

import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import {
  formatDateTime,
  formatNumber,
  getCurrentDate,
} from "../../../../common/Validations";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import WorkflowApproveReject from "../../../../Components/Workflow/WorkflowApproveReject";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";

const CommercialEvaluationDetails = () => {
  // const dispatch = useDispatch();

  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Request for Quotation");

  let rfxNr = useSelector((state) => state?.sourcing?.rfq?.rfxNr); // User Details from Store
  let workflowConfig = useSelector((state) => state?.common?.data?.workflow); // workflowConfig Details from Store
  let sourcingConfig = useSelector((state) => state?.common?.data?.sourcing); // Common Details from Store
  let workflow = useSelector((state) => state?.sourcing?.rfq?.workflowCOMM); // workflowTECH from Store
  let evaluationCriteriaData = useSelector(
    (state) =>
      state?.common?.data?.sourcing?.CommercialEvaluation?.EvaluationCriteria,
  ); // evaluation CriteriaData from Store
  let userData = useSelector((state) => state?.sourcing?.rfq?.data); // User Details from Store
  const [matchObj, setMatchObje] = useState([]);
  useEffect(() => {
    const matchedObject = userData.find((item) => item.rfxNr === rfxNr);
    setMatchObje(matchedObject);
    // eslint-disable-next-line
  }, [rfxNr]);

  const [techData, setTechData] = useState([]);
  const [lineItemData, setLineItemData] = useState([]);
  useState([]);

  const [getTechnicalUserList, setTechnicalUserList] = useState([]);
  // const [getTechnicalEvalHeaderData, setTechnicalEvalHeaderData] = useState([]);

  const [getDropdownData, setDropdownData] = useState("");
  const [getDisabledStatus /* setDisabledStatus */] = useState(true);
  const [getEvaluationCriteria, setEvaluationCriteria] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getExchangeRateData, setExchangeRateData] = useState([]);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisible11, setCardVisible11] = useState(true);
  const [isCardVisible12, setCardVisible12] = useState(true);
  const [isCardVisible13, setCardVisible13] = useState(true);
  const [isCardVisible14, setCardVisible14] = useState(true);
  const [isCardVisible15, setCardVisible15] = useState(true);
  const [isCardVisible16, setCardVisible16] = useState(true);
  const toggleCardVisibility16 = () => {
    setCardVisible16(!isCardVisible16);
  };

  const [getSupplierList, setSupplierList] = useState([]);

  // State for technical evaluation data to identify failed quotations
  const [failedQuotationNrs, setFailedQuotationNrs] = useState([]);

  const [formInputs, setFormInputs] = useState({
    rfxType: "",
    productType: "",
    rfxValue: "",
    rfxHeaderStatus: "",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    buyerResponsible: "",
    companyAddress: "",
    rfxVersion: "",
    buyerEmail: "",
    initiatorName: "",
    initiator: "",
    billingAddressCodeDesc: "",
    createdOn: "",
    buyerConact: "",
    deliveryAddressCodeDesc: "",
    rfxCategoryType: "",
    rfxCategoryCode: "",
    rfxCategoryDesc: "",
    rfqCreation: "",
    rfxTitle: "",
    openingdate: "",
    openingtime: "",
    closingdate: "",
    closingtime: "",
    rfxDescription: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",
    items: "",
    formCOMM: "",
    formTECH: "",
    termsConditions: [],
    supplierList: [],

    openingDateTime: "",
    closingDateTime: "",
    totalHour: "",
    techEvaluationStartedOn: "",
    techEvaluationPreparedOn: "",
    technicalEvaluator: "",
  });

  // Helper: round to 2 decimals
  const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

  // Resolve commercial weight from matchObj (first) then formInputs fallback
  const commercialTotalWeight =
    Number(matchObj?.commercialTotalWeigtage ?? formInputs?.commercialTotalWeigtage) || 0;

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibility11 = () => {
    setCardVisible11(!isCardVisible11);
  };
  const toggleCardVisibility12 = () => {
    setCardVisible12(!isCardVisible12);
  };
  // eslint-disable-next-line no-unused-vars
  const toggleCardVisibility13 = () => {
    setCardVisible13(!isCardVisible13);
  };
  const toggleCardVisibility14 = () => {
    setCardVisible14(!isCardVisible14);
  };
  const toggleCardVisibility15 = () => {
    setCardVisible15(!isCardVisible15);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // Function to handle text changes
  const handleInputChangeTable = (id, value) => {
    const updatedData = formInputs?.supplierList?.map((item) => {
      return item.AssociateNumber === id
        ? {
            ...item,
            qtnSupplierRemarks: value,
          }
        : item;
    });

    setFormInputs((prevState) => ({
      ...prevState, // Keep the other fields in formInputs unchanged
      supplierList: updatedData, // Update the supplierList field
    }));
  };

  const handleWeightageTableRow = (id, value) => {
    const newWeightageValue = Number(value);

    // Calculate the current total weightage without the item to be updated
    const currentTotalWeightage = getEvaluationCriteria.reduce(
      (acc, item) =>
        item.id !== id && item.id !== 5 ? acc + Number(item.weightage) : acc,
      0,
    );

    // Calculate what the new total would be with the updated value
    const newTotalWeightage = currentTotalWeightage + newWeightageValue;

    // Check if the new total exceeds 100
    if (newTotalWeightage > 100) {
      toast.error("Total weightage cannot exceed 100.", {
        duration: 2000,
        position: "top-right",
      });
      return; // Exit the function without updating
    }

    // Update state if total is within allowed range
    setEvaluationCriteria((prevCriteria) =>
      prevCriteria.map((item) =>
        item.id === id
          ? { ...item, weightage: value }
          : item.id === 5
            ? { ...item, weightage: newTotalWeightage }
            : item,
      ),
    );
  };

  const suppliersColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailedPage(row.AssociateNumber)}
        >
          {row.AssociateNumber || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    },

    {
      name: "Supplier ",
      selector: (row) => row.organisationName,
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP Number",
      selector: (row) => row.sapAssociateNumber || "--",
      sortable: true,
      width: "130px",
    },

    {
      name: "Quotation Nr",
      selector: (row) => row.quotationNr || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailedPage(row.AssociateNumber)}
        >
          {row.quotationNr || "-"}{" "}
        </button>
      ),
      width: "140px",
    },
    {
      name: "Qtn Date",
      selector: (row) => formatDateTime(row?.quotationCreatedAt) || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Qtn Version",
      selector: (row) => row?.qtnVersion || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Qtn Value",
      selector: (row) => row?.qtnSubTotalLineItem || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Qtn Currency",
      selector: (row) => row?.qtnBidderCurrencyCode || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: " Tech Doc",
      selector: (row) => row.technicalQuoteArticle,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center"
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Comm Doc",
      selector: (row) => row.commercialQuoteArticle,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center"
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "120px",
    },

    {
      name: "Status",
      selector: (row) => row?.qtnSupplierStatus,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="qtnSupplierStatus"
            value={row?.qtnSupplierStatus}
            // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
            // }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Score",
      selector: (row) => row.commSupplierScore,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="qtnSupplierRemarks"
            value={row.commSupplierScore}
            onChange={(e) =>
              handleInputChangeTable(row.AssociateNumber, e.target.value)
            }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Remarks",
      selector: (row) => row.qtnSupplierRemarks,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="qtnSupplierRemarks"
            value={row.qtnSupplierRemarks}
            onChange={(e) =>
              handleInputChangeTable(row.AssociateNumber, e.target.value)
            }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
  ];
  const CommEvaluationSumColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailedPage(row.AssociateNumber)}
        >
          {row.AssociateNumber || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Supplier ",
      selector: (row) => row.organisationName,
      sortable: true,
      width: "180px",
    },
    {
      name: "Quotation Nr",
      selector: (row) => row.quotationNr || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailedPage(row.AssociateNumber)}
        >
          {row.quotationNr || "-"}{" "}
        </button>
      ),
      width: "140px",
    },
    {
      name: "Initial Qtn Value",
      selector: (row) => row.qtnTotal,
      cell: (row) => (
        <>
          {/* <InputField
            className="inputBox mt-1"
            name="qtnTotal"
            value={formatNumber(row.qtnTotal, "comma")}
            // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
            // }
            disabled={true}
          /> */}
          <>
            {row?.lineItemColor === "green" ? (
              <span className="fw-bold text-success">
                {formatNumber(row?.qtnSubTotalLineItem, "comma")}
              </span>
            ) : (
              <span className="fw-bold text-danger">
                {formatNumber(row?.qtnSubTotalLineItem, "comma")}
              </span>
            )}
          </>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Final Qtn Value",
    //   selector: (row) => row.finalQuotationValue,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="finalQuotationValue"
    //         value={row.finalQuotationValue}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={true}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Final Qtn Value",
      selector: (row) => row?.qtnSubTotalLineItem || "--",
      cell: (row) => (
        <>
          {row?.lineItemColor === "green" ? (
            <span className="fw-bold text-success">
              {formatNumber(row?.qtnSubTotalLineItem, "comma")}
            </span>
          ) : (
            <span className="fw-bold text-danger">
              {formatNumber(row?.qtnSubTotalLineItem, "comma")}
            </span>
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Qtn Currency",
      selector: (row) => row.qtnBidderCurrencyCode,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="qtnBidderCurrencyCode"
            value={row.qtnBidderCurrencyCode}
            // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
            // }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Tech Score",
    //   selector: (row) => row.technicalScore,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="technicalScore"
    //         value={row.technicalScore}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Tech Eval Criteria",
    //   selector: (row) => row.technicalEvalCriteria,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="technicalEvalCriteria"
    //         value={row.technicalEvalCriteria}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Tech WT. Value",
    //   selector: (row) => row.technicalWeightedVal,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="technicalWeightedVal"
    //         value={row.technicalWeightedVal}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Qtn Other Chg",
      selector: (row) => row.qtnSubTotalOtherCharges,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="finalQuotationValue"
            value={row.qtnSubTotalOtherCharges}
            // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
            // }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Qtn Disc.",
    //   selector: (row) => row.qtnDiscTotalCharges,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="qtnDiscTotalCharges"
    //         value={row.qtnDiscTotalCharges}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Qtn Freight Chg.",
    //   selector: (row) => row.qtnFreightTotalCharges,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="qtnFreightTotalCharges"
    //         value={row.qtnFreightTotalCharges}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Incoterm",
      cell: (row) => (
        <>
          <span>{row.qtnIncoTermsDesc || "--"}</span>
        </>
      ),
      selector: (row) => row.qtnIncoTermsDesc,
      sortable: true,
      width: "180px",
    },
    // {
    //   name: "Incoterm Loc",
    //   selector: (row) =>  "--",
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "PaymentTerms",
      cell: (row) => (
        <>
          <span>{row.qtnPaymentTermsDesc || "--"}</span>
        </>
      ),
      selector: (row) => row.qtnPaymentTermsDesc,
      sortable: true,
      width: "180px",
    },
    // {
    //   name: "Shipment cost To Company",
    //   selector: (row) => row.shipmentCost,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="commSupplierRemarks"
    //         value={row.shipmentCost}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },

    // {
    //   name: "Tot Landing Cost",
    //   selector: (row) => row.totLandingCost,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="totLandingCost"
    //         value={row.totLandingCost}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Comm Score",
    //   selector: (row) => row.CommercialScore,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="CommercialScore"
    //         value={row.CommercialScore}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Comm Eval Criteria",
    //   selector: (row) => row.commercialEvalCriteria,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="commercialEvalCriteria"
    //         value={row.commercialEvalCriteria}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Comm WT. Value",
    //   selector: (row) => row.commercialWeightedVal,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="commercialWeightedVal"
    //         value={row.commercialWeightedVal}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "OverallScores",
    //   selector: (row) => row.overallScores,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="overallScores"
    //         value={row.overallScores}
    //         // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         // }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Supplier Rank",
      selector: (row) => row?.lineItemRank,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="bidderRanking"
            value={row?.lineItemRank}
            // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
            // }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row?.qtnSupplierStatus,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="qtnSupplierStatus"
            value={row?.qtnSupplierStatus}
            // onChange={(e) => handleInputChangeTable(row.AssociateNumber, e.target.value)
            // }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Score",
    //   selector: (row) => row.commSupplierScore,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="qtnSupplierRemarks"
    //         value={row.commSupplierScore}
    //         onChange={(e) =>
    //           handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Remarks",
    //   selector: (row) => row.commSupplierRemarks,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="commSupplierRemarks"
    //         value={row.commSupplierRemarks}
    //         onChange={(e) =>
    //           handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         }
    //         disabled={getDisabledStatus}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Score",
      selector: (row) => row.commSupplierScore,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="qtnSupplierRemarks"
            value={row.commSupplierScore}
            onChange={(e) =>
              handleInputChangeTable(row.AssociateNumber, e.target.value)
            }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Remarks",
      selector: (row) => row.qtnSupplierRemarks,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="qtnSupplierRemarks"
            value={row.qtnSupplierRemarks}
            onChange={(e) =>
              handleInputChangeTable(row.AssociateNumber, e.target.value)
            }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
  ];
  const CommAwardSummaryColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,

      width: "120px",
    },
    {
      name: "Supplier ",
      selector: (row) => row.organisationName,
      sortable: true,
      width: "180px",
    },
    {
      name: "Quotation Nr",
      selector: (row) => row.quotationNr || "--",
      sortable: true,

      width: "140px",
    },
    // {
    //   name: "Quotation Version",
    //   selector: (row) => row.quotationNr || "--",
    //   sortable: true,

    //   width: "140px",
    // },
    // {
    //   name: "RFQ Currency",
    //   selector: (row) => row?.qtnSubTotalLineItem || "--",
    //   cell: (row) => (
    //     <>
    //       {row?.lineItemColor === "green" ? (
    //         <span className="fw-bold text-success">
    //           {formatNumber(row?.qtnSubTotalLineItem, "comma")}
    //         </span>
    //       ) : (
    //         <span className="fw-bold text-danger">
    //           {formatNumber(row?.qtnSubTotalLineItem, "comma")}
    //         </span>
    //       )}
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Initial Qtn Value",
      selector: (row) => row?.qtnSubTotalLineItem || "--",
      cell: (row) => (
        <>
          {row?.lineItemColor === "green" ? (
            <span className="fw-bold text-success">
              {formatNumber(row?.qtnSubTotalLineItem, "comma")}
            </span>
          ) : (
            <span className="fw-bold text-danger">
              {formatNumber(row?.qtnSubTotalLineItem, "comma")}
            </span>
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Final Qtn Value",
      selector: (row) => row?.qtnSubTotalLineItem || "--",
      cell: (row) => (
        <>
          {row?.lineItemColor === "green" ? (
            <span className="fw-bold text-success">
              {formatNumber(row?.qtnSubTotalLineItem, "comma")}
            </span>
          ) : (
            <span className="fw-bold text-danger">
              {formatNumber(row?.qtnSubTotalLineItem, "comma")}
            </span>
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Qtn Currency",
      selector: (row) => row?.qtnBidderCurrencyCode || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Other Chg",
      selector: (row) => row?.qtnSubTotalOtherCharges || "--",
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Disc.",
    //   selector: (row) => "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Freight Chg.",
    //   selector: (row) => "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Final Award Value",
    //   selector: (row) => "--",
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Incoterm",
      selector: (row) => row?.qtnIncoTermsDesc || "--",
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Incoterm Loc",
    //   selector: (row) => "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Shipment cost To Company",
    //   selector: (row) => "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Tot Landing Cost",
    //   selector: (row) => "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Total Cost",
    //   selector: (row) => "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Exchange Rate",
    //   selector: (row) => "--",
    //   sortable: true,
    //   width: "180px",
    // },
    // {
    //   name: "Qtn Bid Currency",
    //   selector: (row) => "--",
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Final Award Value",
      cell: (row) => (
        <>
          {row?.lineItemColor === "green" ? (
            <span className="fw-bold text-success">
              {formatNumber(
                row?.qtnSubTotalLineItem + row?.qtnSubTotalOtherCharges,
                "comma",
              )}
            </span>
          ) : (
            <span className="fw-bold text-danger">
              {formatNumber(
                row?.qtnSubTotalLineItem + row?.qtnSubTotalOtherCharges,
                "comma",
              )}
            </span>
          )}
        </>
      ),
      selector: (row) => "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Final Award Qty",
      selector: (row) => (row?.totalAwardQty ?? row?.awardQty) || "--",
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Status",
    //   selector: (row) => "--",
    //   sortable: true,
    //   width: "100px",
    // },
    // {
    //   name: "Score",
    //   selector: (row) => row.commSupplierScore,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="qtnSupplierRemarks"
    //         value={row.commSupplierScore}
    //         onChange={(e) =>
    //           handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         }
    //         disabled={true}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Remarks",
    //   selector: (row) => row.commSupplierRemarks,
    //   cell: (row) => (
    //     <>
    //       <InputField
    //         className="inputBox mt-1"
    //         name="commSupplierRemarks"
    //         value={row.commSupplierRemarks}
    //         onChange={(e) =>
    //           handleInputChangeTable(row.AssociateNumber, e.target.value)
    //         }
    //         disabled={true}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Score",
      selector: (row) => row.commSupplierScore,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="qtnSupplierRemarks"
            value={row.commSupplierScore}
            onChange={(e) =>
              handleInputChangeTable(row.AssociateNumber, e.target.value)
            }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Remarks",
      selector: (row) => row.qtnSupplierRemarks,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="qtnSupplierRemarks"
            value={row.qtnSupplierRemarks}
            onChange={(e) =>
              handleInputChangeTable(row.AssociateNumber, e.target.value)
            }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
  ];
  const evaluationCriteriaColumns = [
    {
      name: "Sl No",
      selector: (row) => row.slno,
      sortable: true,
      cell: (row) =>
        row.slno === "Total" ? (
          <span className="fw-bold"> {row.slno} </span>
        ) : (
          row.slno
        ),
      width: "150px",
    },
    {
      name: "Criteria",
      selector: (row) => row.criteria,
      sortable: true,
      cell: (row) => <span>{row.criteria}</span>,
      width: "600px",
    },
    {
      name: "Weightage",
      selector: (row) => row.weightage,
      sortable: true,
      cell: (row) =>
        row.id === 5 ? (
          <span className="numberFormate fw-bold pr-5"> {row.weightage} </span>
        ) : (
          <InputField
            type="number"
            className="inputBox mt-1 text-end"
            id="weightage"
            name="weightage"
            value={row.weightage || 0}
            onChange={(e) => handleWeightageTableRow(row.id, e.target.value)}
            // onBlur={(e) =>
            //   handleWeightageValueCal(row.id, e.target.value)
            // }
            disabled={true}
          />
        ),
      width: "120px",
    },
  ];

  // eslint-disable-next-line no-unused-vars
  const exchangeRateColumns = [
    {
      name: "Bidder Currency",
      selector: (row) => row.bidderCurrency,
      sortable: true,
      cell: (row) => <span>{row.bidderCurrency}</span>,
    },
    {
      name: "RFQ Currency",
      selector: (row) => row.RFQCurrency,
      sortable: true,
      cell: (row) => <span>{row.RFQCurrency}</span>,
    },
    {
      name: "Value",
      selector: (row) => row.value,
      sortable: true,
      cell: (row) => <span>{row.value}</span>,
    },
    {
      name: "Exchange Rate",
      selector: (row) => row.exchangeRate,
      sortable: true,
      cell: (row) => <span>{row.exchangeRate}</span>,
    },
  ];

  //Exchange Rate
  const loadExchangeRateData = async () => {
    let obj = {
      queryName: "getExchangeRateDetails",
      // documentNumber: rfxNr,
      documentNumber: "RFX0059",
    };
    await ItemService.generateQuery(obj).then((item) => {
      console.log(">> res!", item);
      if (item?.status === 200) {
        // setTechnicalEvalHeaderData(item?.data[0]);
        setTimeout(() => {
          // console.log(">> setTechData", item?.data);
          setTechData(item?.data);
          setLineItemData(item?.data);
        }, 1000);
        setExchangeRateData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  // Load data
  const loadCommercialEvaluationData = async () => {
    if (rfxNr) {
      let obj = {
        queryName: "getRFXCommEvaluationDetail",
        rfxNr: rfxNr,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.generateQuery(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          // Suppose "data" is your response array (item.data)
          const data = item?.data[0]?.supplierList || [];
          // 1. Sort a copy by qtnSubTotalLineItem
          const sorted = [...data].sort(
            (a, b) => a.qtnSubTotalLineItem - b.qtnSubTotalLineItem,
          );
          // 2. Create a Map from value to rank (handles ties)
          const valueToRank = new Map();
          let rank = 1;
          for (let i = 0; i < sorted.length; i++) {
            const value = sorted[i].qtnSubTotalLineItem;
            if (!valueToRank.has(value)) {
              valueToRank.set(value, rank);
              rank++;
            }
          }
          // 3. Map original data to include both rank and color
          const rankedData = data.map((d) => {
            const itemRank = valueToRank.get(d.qtnSubTotalLineItem);
            return {
              ...d,
              lineItemRank: itemRank,
              lineItemColor: itemRank === 1 ? "green" : "red",
            };
          });
          // 4. Use rankedData in your state
          // Set this to your state
          setSupplierList(rankedData);

          setFormInputs(item.data[0]);

          // if (item?.data[0]?.rfxHeaderStatus === "Tech Approved") {
          //   setDisabledStatus(false);
          // } else {
          //   setDisabledStatus(false);
          // }

          setTimeout(() => {
            setTechData(item?.data);
            setLineItemData(item?.data);
          }, 500);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      // setLoading(false);
    } else {
      // window.history.back();
    }
  };

  // From Child Component
  const handleEvaluationTableData = (data) => {
    // console.log(">> child tech ", data);
    // Keep all quotations (failed ones stay visible but disabled via
    // disabledQuotationNrs passed to the child EvaluationTable).
    setFormInputs((formInputs) => ({
      ...formInputs,
      rfxQuestions: data,
    }));
  };

  // From Child Component
  const handleItemData = (data) => {
    // console.log(">> item tech ", data);
    // setItemTableData(data);
    setFormInputs((formInputs) => ({
      ...formInputs,
      items: data,
    }));
  };

  useEffect(() => {
    // loadInitialPageData();
    loadCommercialEvaluationData();
    loadTechnicalEvaluationData();
    loadTechUser();
    loadExchangeRateData();
    formInputs.techEvaluationStartedOn = getCurrentDate("");
    formInputs.techEvaluationPreparedOn = getCurrentDate("");
    setEvaluationCriteria(evaluationCriteriaData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxNr]);

  // Load technical evaluation data to identify failed quotations
  const loadTechnicalEvaluationData = async () => {
    if (rfxNr) {
      let obj = {
        queryName: "getRFXTechEvaluationDetail",
        documentNumber: rfxNr,
      };
      await ItemService.generateQuery(obj).then((item) => {
        if (item?.status === 200) {
          // Extract failed quotation numbers where quotationTechEvaluation === "FAIL"
          const failed = item?.data
            ?.flatMap((d) => d?.supplierList || [])
            .filter((s) => s?.quotationTechEvaluation === "FAIL")
            .map((s) => s?.quotationNr) || [];
          setFailedQuotationNrs(failed);
        } else {
          console.log(">> Error loading technical evaluation data:", item?.message);
        }
      });
    }
  };

  // Compute and stamp per-quotation commercial totals + weighted score
  useEffect(() => {
    if (!techData?.length) return;

    // Compute total score per quotationNr from commercial evaluation table
    const scoreByQuotationNr = {};
    techData.forEach((question) => {
      (question?.quotationDocument || []).forEach((doc) => {
        if (!doc?.quotationNr) return;
        scoreByQuotationNr[doc.quotationNr] =
          (scoreByQuotationNr[doc.quotationNr] || 0) + (Number(doc?.score) || 0);
      });
    });

    // Stamp onto formInputs.supplierList (travels on create/update/approve)
    setFormInputs((formInputs) => {
      const supplierList = (formInputs.supplierList || []).map((supplier) => {
        const totalScore = scoreByQuotationNr[supplier?.quotationNr] || 0;
        const weighted = round2((totalScore * commercialTotalWeight) / 100);
        return {
          ...supplier,
          commercialTotalScore: totalScore,
          weightedCommercialScore: weighted,
        };
      });
      return { ...formInputs, supplierList };
    });
  }, [techData, commercialTotalWeight]);

  const loadTechUser = async () => {
    let obj = {
      roleId: "COMMERCIAL",
    };
    await ItemService.getCommercialUser(obj).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setTechnicalUserList(item?.data);
      } else {
        setTechnicalUserList([]);
        console.log(">> Error: Loading loadTechUser");
      }
    });
  };

  // Get Dropdown data select
  useEffect(() => {
    // console.log(">>datarfq", getDropdownData);
    if (getDropdownData?.name) {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const handleEditorChange = (content) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      instructions: content,
    }));
  };
  const handleEditorChangeInstuctions = (content) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      instructionsJustificationMemo: content,
    }));
  };

  // ── XL Export Helpers ──────────────────────────────────────────────
  const exportToExcel = (data, columns, fileName) => {
    if (!data?.length) {
      toast.error("No data available to export");
      return;
    }
    const headers = columns.map((col) => col.name);
    const rows = data.map((row) =>
      columns.map((col) => {
        try {
          return typeof col.selector === "function"
            ? col.selector(row)
            : row[col.id] || "";
        } catch {
          return "";
        }
      }),
    );
    const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    ws["!cols"] = headers.map((h, i) => ({
      wch: Math.max(h.length, ...rows.map((r) => String(r[i] || "").length)),
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, fileName);
  };

  const handleExportEvalCriteria = () => {
    exportToExcel(
      getEvaluationCriteria,
      evaluationCriteriaColumns,
      `Evaluation_Criteria_${rfxNr}.xlsx`,
    );
  };

  const handleExportCommEvalQuestions = async () => {
    const questions = formInputs?.rfxQuestions || [];
    if (!questions?.length) {
      toast.error("No evaluation questions data available");
      return;
    }
    const suppliers = questions[0]?.quotationDocument || [];

    // Calculate total score per supplier and sort descending (highest score first)
    const scoreBySupplier = {};
    questions.forEach((q) => {
      (q.quotationDocument || []).forEach((d) => {
        const nr = d.quotationNr;
        scoreBySupplier[nr] = (scoreBySupplier[nr] || 0) + Number(d.score || 0);
      });
    });

    const sortedSuppliers = [...suppliers].sort((a, b) => {
      return (
        (scoreBySupplier[b.quotationNr] || 0) -
        (scoreBySupplier[a.quotationNr] || 0)
      );
    });

    // Row 1: merged supplier header (4 empty cols, then each supplier spans 3 cols)
    const headerRow1 = [
      "",
      "",
      "",
      "",
      ...sortedSuppliers.flatMap((s, i) => [
        `${s.organisationName} - ${s.quotationNr} (L${i + 1})`,
        "",
        "",
      ]),
    ];

    // Row 2: column sub-headers
    const headerRow2 = [
      "Sl No",
      "Questionaries",
      "Criteria",
      "Weightage",
      ...sortedSuppliers.flatMap(() => [
        "Supplier Response",
        "Score",
        "Comments",
      ]),
    ];

    // Data rows
    const dataRows = questions.map((q) => {
      const row = [
        q.serialNo,
        q.question?.label || "",
        q.criteria || "",
        q.weightage || 0,
      ];
      sortedSuppliers.forEach((s) => {
        const doc = q.quotationDocument?.find(
          (d) => d.quotationNr === s.quotationNr,
        );
        const formResponse = doc
          ? (doc.formCOMM || []).find((f) => f.question_no === q.componentId)
          : null;
        row.push(formResponse?.question_value || "--");
        row.push(doc?.score || 0);
        row.push(doc?.comments || "");
      });
      return row;
    });

    // Total footer row
    const totalWeightage = questions.reduce(
      (sum, q) => sum + Number(q.weightage || 0),
      0,
    );
    const totalRow = ["", "Total", "", totalWeightage];
    sortedSuppliers.forEach((s) => {
      totalRow.push("", scoreBySupplier[s.quotationNr] || 0, "");
    });

    const allRows = [headerRow1, headerRow2, ...dataRows, totalRow];

    // Create workbook with exceljs for proper bold styling
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    // Add all data rows
    worksheet.addRows(allRows);

    // Merge supplier cells in header row 1 (row 0)
    sortedSuppliers.forEach((_, i) => {
      const startCol = 4 + i * 3 + 1; // exceljs is 1-indexed
      worksheet.mergeCells(1, startCol, 1, startCol + 2);
    });

    // Bold the L1 supplier's columns (highest score) — cols 4,5,6 → 1-indexed: 5,6,7
    if (sortedSuppliers.length > 0) {
      for (let r = 1; r <= allRows.length; r++) {
        for (let c = 5; c <= 7; c++) {
          const cell = worksheet.getCell(r, c);
          cell.font = { bold: true };
        }
      }
    }

    // Set column widths
    allRows[0].forEach((_, i) => {
      const col = worksheet.getColumn(i + 1);
      let maxLen = 0;
      allRows.forEach((r) => {
        const len = String(r[i] ?? "").length;
        if (len > maxLen) maxLen = len;
      });
      col.width = Math.min(maxLen + 3, 50);
    });

    // Write buffer and download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Comm_Eval_Questions_${rfxNr}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleExportLineItems = () => {
    const items = formInputs?.items || [];
    if (!items?.length) {
      toast.error("No line item data available");
      return;
    }
    const suppliers = items[0]?.quotationDocument || [];

    // Calculate total price per supplier (sum of qtnitemValue) and sort ascending (lowest first)
    const totalBySupplier = {};
    items.forEach((item) => {
      (item.quotationDocument || []).forEach((d) => {
        const nr = d.quotationNr;
        totalBySupplier[nr] =
          (totalBySupplier[nr] || 0) + Number(d.qtnitemValue || 0);
      });
    });

    const sortedSuppliers = [...suppliers].sort((a, b) => {
      return (
        (totalBySupplier[a.quotationNr] || 0) -
        (totalBySupplier[b.quotationNr] || 0)
      );
    });

    // Row 1: merged supplier header (7 empty cols, then each supplier spans 6 cols)
    const headerRow1 = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ...sortedSuppliers.flatMap((s, i) => [
        `${s.organisationName} - ${s.quotationNr} (L${i + 1})`,
        "",
        "",
        "",
        "",
        "",
      ]),
    ];

    // Row 2: column sub-headers matching CommLineItemTable
    const headerRow2 = [
      "SL No",
      "Purchase Document",
      "Status",
      "Material Code",
      "Qty",
      "Unit",
      "Item Text",
      ...sortedSuppliers.flatMap(() => [
        "Tech Eval",
        "Initial Price",
        "Final Price",
        "Net Unit Price",
        "Award Qty",
        "Award Value",
      ]),
    ];

    // Data rows
    const dataRows = items.map((item) => {
      const row = [
        item.local_id,
        item.purchaseReqDocumentNr || "",
        item.statusItem || "",
        `${item.materialCode || ""} - ${item.materialDescription || ""}`,
        item.purchaseQuantity || "",
        item.orderUnitOfMeasure || "",
        "",
      ];
      sortedSuppliers.forEach((s) => {
        const doc = item.quotationDocument?.find(
          (d) => d.quotationNr === s.quotationNr,
        );
        row.push(doc?.approveReject || "-");
        row.push(doc?.quotationUnitPrice || 0);
        row.push(doc?.quotationUnitPrice || 0);
        row.push(doc?.qtnitemValue || 0);
        row.push(doc?.awardQty || 0);
        row.push(doc?.awardValue || 0);
      });
      return row;
    });

    const allRows = [headerRow1, headerRow2, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(allRows);

    // Merge supplier cells in header row 1 (row 0)
    ws["!merges"] = sortedSuppliers.map((_, i) => {
      const startCol = 7 + i * 6;
      return {
        s: { r: 0, c: startCol },
        e: { r: 0, c: startCol + 5 },
      };
    });

    ws["!cols"] = allRows[0].map((_, i) => ({
      wch: Math.max(...allRows.map((r) => String(r[i] || "").length)),
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `Line_Items_${rfxNr}.xlsx`);
  };

  const handleExportAwardSummary = () => {
    if (!getSupplierList?.length) {
      toast.error("No award summary data available");
      return;
    }
    const data = [...getSupplierList];
    // Sort by Final Award Value (qtnSubTotalLineItem + qtnSubTotalOtherCharges) ascending
    data.sort(
      (a, b) =>
        (Number(a.qtnSubTotalLineItem) || 0) +
        (Number(a.qtnSubTotalOtherCharges) || 0) -
        ((Number(b.qtnSubTotalLineItem) || 0) +
          (Number(b.qtnSubTotalOtherCharges) || 0)),
    );
    // Add rank labels to quotation number
    // Calculate total award qty per supplier from line items
    const awardQtyBySupplier = {};
    (formInputs?.items || []).forEach((item) => {
      (item.quotationDocument || []).forEach((doc) => {
        const nr = doc.quotationNr;
        awardQtyBySupplier[nr] =
          (awardQtyBySupplier[nr] || 0) + Number(doc.awardQty || 0);
      });
    });
    const rankedData = data.map((row, i) => ({
      ...row,
      quotationNr: `${row.quotationNr || "--"} (L${i + 1})`,
      totalAwardQty: awardQtyBySupplier[row.quotationNr] || 0,
    }));
    exportToExcel(
      rankedData,
      CommAwardSummaryColumns,
      `Award_Summary_${rfxNr}.xlsx`,
    );
  };

  const handleExportCommEvalSummary = () => {
    exportToExcel(
      getSupplierList,
      CommEvaluationSumColumns,
      `Comm_Evaluation_Summary_${rfxNr}.xlsx`,
    );
  };

  const handleExportAll = async () => {
    const hasAnyData =
      getEvaluationCriteria?.length ||
      formInputs?.rfxQuestions?.length ||
      getSupplierList?.length ||
      formInputs?.items?.length;
    if (!hasAnyData) {
      toast.error("No data available to export");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    workbook.creator = "Sourcing Portal";
    const worksheet = workbook.addWorksheet("Techno Commercial Comparison");

    // ── Styling palette & helpers ──────────────────────────────────
    const P = {
      titleFill: "FF1F4E78",
      titleFont: "FFFFFFFF",
      sectionFill: "FF2E75B6",
      sectionFont: "FFFFFFFF",
      headerFill: "FF4472C4",
      headerFont: "FFFFFFFF",
      bandFill: "FFF7F9FC",
      bestFill: "FFC6EFCE",
      bestFont: "FF006100",
      badFill: "FFFFC7CE",
      badFont: "FF9C0006",
      l1Fill: "FFC6EFCE",
      l1Font: "FF006100",
      groupFill: "FFD9E1F2",
      groupFont: "FF1F3864",
      totalFill: "FFDDEBF7",
      totalFont: "FF1F4E78",
      border: "FFB4C6E7",
    };
    const border = {
      top: { style: "thin", color: { argb: P.border } },
      left: { style: "thin", color: { argb: P.border } },
      bottom: { style: "thin", color: { argb: P.border } },
      right: { style: "thin", color: { argb: P.border } },
    };
    const f = (bold = false, color = "FF000000", size = 11) => ({
      bold,
      color: { argb: color },
      size,
    });
    const setCell = (r, c, v, font, fillArg = null, align = null, numFmt = null) => {
      const cell = worksheet.getCell(r, c);
      cell.value = v;
      if (font) cell.font = font;
      if (fillArg)
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: fillArg },
        };
      if (align) cell.alignment = align;
      if (numFmt) cell.numFmt = numFmt;
      cell.border = border;
      return cell;
    };
    const styleRange = (startR, startC, endR, endC, font, fillArg, align) => {
      for (let r = startR; r <= endR; r++) {
        for (let c = startC; c <= endC; c++) {
          const cell = worksheet.getCell(r, c);
          if (font) cell.font = font;
          if (fillArg)
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: fillArg },
            };
          if (align) cell.alignment = align;
          cell.border = border;
        }
      }
    };

    // ── Build all sections first (so the title band spans full width) ─
    const sections = [];

    // 1. Evaluation Criteria
    if (getEvaluationCriteria?.length) {
      sections.push({
        title: "1. Evaluation Criteria",
        headers: evaluationCriteriaColumns.map((c) => c.name),
        rows: getEvaluationCriteria.map((r) =>
          evaluationCriteriaColumns.map((c) => {
            try {
              return typeof c.selector === "function"
                ? c.selector(r)
                : r[c.id] ?? "";
            } catch {
              return "";
            }
          }),
        ),
        flat: true,
        boldRows: getEvaluationCriteria
          .map((r, i) => (String(r?.slno).toLowerCase() === "total" ? i : -1))
          .filter((i) => i >= 0),
      });
    }

    // Grouped questions section builder (technical & commercial)
    const buildQuestionsSection = (questions, formKey, title) => {
      const suppliers = questions[0]?.quotationDocument || [];
      const scoreBySupplier = {};
      questions.forEach((q) => {
        (q.quotationDocument || []).forEach((d) => {
          if (!d?.quotationNr) return;
          scoreBySupplier[d.quotationNr] =
            (scoreBySupplier[d.quotationNr] || 0) + Number(d.score || 0);
        });
      });
      const sortedSuppliers = [...suppliers].sort(
        (a, b) =>
          (scoreBySupplier[b.quotationNr] || 0) -
          (scoreBySupplier[a.quotationNr] || 0),
      );
      const rankByNr = {};
      sortedSuppliers.forEach((s, i) => {
        rankByNr[s.quotationNr] = i + 1;
      });

      const dataRows = questions.map((q) => {
        const row = [q.serialNo, q.question?.label || "", q.criteria || "", q.weightage || 0];
        sortedSuppliers.forEach((s) => {
          const doc = q.quotationDocument?.find(
            (d) => d.quotationNr === s.quotationNr,
          );
          const formResponse = doc
            ? (doc[formKey] || []).find((fl) => fl.question_no === q.componentId)
            : null;
          row.push(formResponse?.question_value ?? "--");
          row.push(doc?.score ?? 0);
        });
        return row;
      });

      const totalWeightage = questions.reduce(
        (sum, q) => sum + Number(q.weightage || 0),
        0,
      );
      const totalRow = ["", "Total", "", totalWeightage];
      let bestScore = -Infinity;
      let bestGi = 0;
      sortedSuppliers.forEach((s, gi) => {
        const sc = scoreBySupplier[s.quotationNr] || 0;
        totalRow.push("", sc);
        if (sc > bestScore) {
          bestScore = sc;
          bestGi = gi;
        }
      });

      const averageRow = ["", "Average", "", ""];
      sortedSuppliers.forEach((s) => {
        averageRow.push("", round2((scoreBySupplier[s.quotationNr] || 0) / (questions.length || 1)));
      });

      const staticCols = 4;
      const groupSpan = 2;
      sections.push({
        title,
        grouped: true,
        staticCols,
        groupSpan,
        groupHeaders: sortedSuppliers.map(
          (s) => `${s.organisationName} - ${s.quotationNr} (L${rankByNr[s.quotationNr]})`,
        ),
        groupBest: sortedSuppliers.map((s) => rankByNr[s.quotationNr] === 1),
        subHeaders: [
          "SL No",
          "Questionaries",
          "Criteria",
          "Weightage",
          ...sortedSuppliers.flatMap(() => [
            "Supplier Response",
            "Score",
          ]),
        ],
        dataRows,
        averageRow,
        totalRow,
        totalBestScoreCol: staticCols + 1 + bestGi * groupSpan,
      });
    };

    // Classify questions into Technical / Commercial bands by the answers each
    // supplier entered (formTECH vs formCOMM), mirroring the on-screen table.
    const techQuestions = (formInputs?.rfxQuestions || []).filter((q) =>
      (q.quotationDocument || []).some((doc) =>
        (doc.formTECH || []).some((f) => f.question_no === q.componentId)
      )
    );
    const commQuestions = (formInputs?.rfxQuestions || []).filter((q) =>
      (q.quotationDocument || []).some((doc) =>
        (doc.formCOMM || []).some((f) => f.question_no === q.componentId)
      )
    );
    const allQuestions = [...techQuestions, ...commQuestions];

    if (allQuestions.length) {
      if (techQuestions.length) {
        buildQuestionsSection(techQuestions, "formTECH", "2. Technical Evaluation");
      }
      if (commQuestions.length) {
        buildQuestionsSection(commQuestions, "formCOMM", "3. Commercial Evaluation");
      }

      // 4. Techno Commercial Weighted Score
      const suppliers = allQuestions[0]?.quotationDocument || [];
      const scoreBySupplier = {};
      allQuestions.forEach((q) => {
        (q.quotationDocument || []).forEach((d) => {
          if (!d?.quotationNr) return;
          scoreBySupplier[d.quotationNr] =
            (scoreBySupplier[d.quotationNr] || 0) + Number(d.score || 0);
        });
      });
      const sortedSuppliers = [...suppliers].sort(
        (a, b) =>
          (scoreBySupplier[b.quotationNr] || 0) -
          (scoreBySupplier[a.quotationNr] || 0),
      );
      const rankByNr = {};
      sortedSuppliers.forEach((s, i) => {
        rankByNr[s.quotationNr] = i + 1;
      });
      const techScoreBySupplier = {};
      techQuestions.forEach((q) => {
        (q.quotationDocument || []).forEach((d) => {
          if (!d?.quotationNr) return;
          techScoreBySupplier[d.quotationNr] =
            (techScoreBySupplier[d.quotationNr] || 0) + Number(d.score || 0);
        });
      });
      const techWeight = Number(matchObj?.technicalTotalWeight ?? formInputs?.technicalTotalWeight) || 0;
      const allScores = Object.values(scoreBySupplier);
      const averageAll = allScores.length
        ? round2(allScores.reduce((a, b) => a + b, 0) / allScores.length)
        : 0;

      const totalRow = ["", "Total Score"];
      sortedSuppliers.forEach((s) => {
        totalRow.push(scoreBySupplier[s.quotationNr] || 0);
      });
      const averageRow = ["", "Average"];
      sortedSuppliers.forEach(() => {
        averageRow.push(averageAll);
      });
      const pointsRow = [``, `Technical Points (${techWeight}%)`];
      sortedSuppliers.forEach((s) => {
        pointsRow.push(round2((techScoreBySupplier[s.quotationNr] || 0) * techWeight / 100));
      });

      const staticCols = 2;
      const groupSpan = 1;
      // sortedSuppliers is ordered by total score descending, so L1 sits first
      const bestGi = 0;
      sections.push({
        title: "4. Techno Commercial Weighted Score",
        grouped: true,
        staticCols,
        groupSpan,
        groupHeaders: sortedSuppliers.map(
          (s) => `${s.organisationName} - ${s.quotationNr} (L${rankByNr[s.quotationNr]})`,
        ),
        groupBest: sortedSuppliers.map((s) => rankByNr[s.quotationNr] === 1),
        subHeaders: ["", "Points", ...sortedSuppliers.map(() => "")],
        dataRows: [totalRow, averageRow, pointsRow],
        totalRow: [],
        totalBestScoreCol: staticCols + 1 + bestGi * groupSpan,
      });
    }

    // 5. Commercial Evaluation Summary
    if (getSupplierList?.length) {
      sections.push({
        title: "5. Commercial Evaluation Summary",
        headers: [
          "Supplier ID",
          "Supplier",
          "Quotation Nr",
          "Initial Qtn Value",
          "Final Qtn Value",
          "Qtn Currency",
          "Qtn Other Chg",
          "Incoterm",
          "Payment Terms",
          "Supplier Rank",
          "Status",
          "Score",
          "Remarks",
        ],
        rows: getSupplierList.map((row) => [
          row.AssociateNumber || "--",
          row.organisationName || "--",
          row.quotationNr || "--",
          Number(row.qtnSubTotalLineItem) || 0,
          Number(row.qtnSubTotalLineItem) || 0,
          row.qtnBidderCurrencyCode || "--",
          Number(row.qtnSubTotalOtherCharges) || 0,
          row.qtnIncoTermsDesc || "--",
          row.qtnPaymentTermsDesc || "--",
          row.lineItemRank ?? "--",
          row.qtnSupplierStatus || "--",
          row.commSupplierScore ?? "--",
          row.qtnSupplierRemarks || "",
        ]),
        flat: true,
        moneyCols: [3, 4, 6],
        bestRows: getSupplierList.map((row) => Number(row.lineItemRank) === 1),
      });
    }

    // 6. Line Item
    const items = formInputs?.items;
    if (items?.length) {
      const suppliers = items[0]?.quotationDocument || [];
      const totalBySupplier = {};
      const netTotalBySupplier = {};
      const awardQtyBySupplier = {};
      const awardValBySupplier = {};
      items.forEach((item) => {
        (item.quotationDocument || []).forEach((d) => {
          if (!d?.quotationNr) return;
          const nr = d.quotationNr;
          totalBySupplier[nr] =
            (totalBySupplier[nr] || 0) + Number(d.qtnitemValue || 0);
          netTotalBySupplier[nr] =
            (netTotalBySupplier[nr] || 0) + Number(d.qtnitemValue || 0);
          awardQtyBySupplier[nr] =
            (awardQtyBySupplier[nr] || 0) + Number(d.awardQty || 0);
          awardValBySupplier[nr] =
            (awardValBySupplier[nr] || 0) + Number(d.awardValue || 0);
        });
      });
      const sortedSuppliers = [...suppliers].sort(
        (a, b) =>
          (totalBySupplier[a.quotationNr] || 0) -
          (totalBySupplier[b.quotationNr] || 0),
      );
      const rankByNr = {};
      sortedSuppliers.forEach((s, i) => {
        rankByNr[s.quotationNr] = i + 1;
      });

      const dataRows = items.map((item) => {
        const row = [
          item.rfxItemNr || item.local_id,
          item.purchaseReqDocumentNr || "",
          item.prStatusItem || item.statusItem || "-",
          `${item.materialCode || ""} - ${item.materialDescription || ""}`,
          item.purchaseQuantity || "",
          item.orderUnitOfMeasure || "",
          "",
        ];
        sortedSuppliers.forEach((s) => {
          const doc = item.quotationDocument?.find(
            (d) => d.quotationNr === s.quotationNr,
          );
          row.push(doc?.approveReject || "-");
          row.push(Number(doc?.quotationUnitPrice) || 0);
          row.push(Number(doc?.quotationUnitPrice) || 0);
          row.push(Number(doc?.qtnitemValue) || 0);
          row.push(Number(doc?.awardQty) || 0);
          row.push(Number(doc?.awardValue) || 0);
        });
        return row;
      });

      // Total row: net price / award qty / award value per supplier
      let bestNet = Infinity;
      let bestGi = 0;
      const totalRow = ["", "Total", "", "", "", "", ""];
      sortedSuppliers.forEach((s, gi) => {
        const net = netTotalBySupplier[s.quotationNr] || 0;
        if (net < bestNet) {
          bestNet = net;
          bestGi = gi;
        }
        totalRow.push(
          "",
          "",
          "",
          net,
          awardQtyBySupplier[s.quotationNr] || 0,
          awardValBySupplier[s.quotationNr] || 0,
        );
      });

      const staticCols = 7;
      const groupSpan = 6;
      sections.push({
        title: "6. Line Item",
        grouped: true,
        staticCols,
        groupSpan,
        groupHeaders: sortedSuppliers.map(
          (s) => `${s.organisationName} - ${s.quotationNr} (L${rankByNr[s.quotationNr]})`,
        ),
        groupBest: sortedSuppliers.map((s) => rankByNr[s.quotationNr] === 1),
        subHeaders: [
          "SL No",
          "Purchase Document",
          "Status",
          "Material Code",
          "Qty",
          "Unit",
          "Item Text",
          ...sortedSuppliers.flatMap(() => [
            "Tech Eval",
            "Initial Price",
            "Final Price",
            "Net Unit Price",
            "Award Qty",
            "Award Value",
          ]),
        ],
        dataRows,
        totalRow,
        totalBestScoreCol: staticCols + 4 + bestGi * groupSpan,
        moneyOffsets: [1, 2, 3, 5],
      });
    }

    // 7. Award Summary
    if (getSupplierList?.length) {
      const data = [...getSupplierList].sort(
        (a, b) =>
          (Number(a.qtnSubTotalLineItem) || 0) +
          (Number(a.qtnSubTotalOtherCharges) || 0) -
          ((Number(b.qtnSubTotalLineItem) || 0) +
            (Number(b.qtnSubTotalOtherCharges) || 0)),
      );
      const awardQtyBySupplier = {};
      (formInputs?.items || []).forEach((item) => {
        (item.quotationDocument || []).forEach((doc) => {
          if (!doc?.quotationNr) return;
          awardQtyBySupplier[doc.quotationNr] =
            (awardQtyBySupplier[doc.quotationNr] || 0) +
            Number(doc.awardQty || 0);
        });
      });
      sections.push({
        title: "7. Award Summary",
        headers: [
          "Supplier ID",
          "Supplier",
          "Quotation Nr",
          "Initial Qtn Value",
          "Final Qtn Value",
          "Qtn Currency",
          "Other Chg",
          "Incoterm",
          "Final Award Value",
          "Final Award Qty",
          "Score",
          "Remarks",
        ],
        rows: data.map((row, i) => [
          row.AssociateNumber || "--",
          row.organisationName || "--",
          `${row.quotationNr || "--"} (L${i + 1})`,
          Number(row.qtnSubTotalLineItem) || 0,
          Number(row.qtnSubTotalLineItem) || 0,
          row.qtnBidderCurrencyCode || "--",
          Number(row.qtnSubTotalOtherCharges) || 0,
          row.qtnIncoTermsDesc || "--",
          (Number(row.qtnSubTotalLineItem) || 0) +
            (Number(row.qtnSubTotalOtherCharges) || 0),
          awardQtyBySupplier[row.quotationNr] || 0,
          row.commSupplierScore ?? "--",
          row.qtnSupplierRemarks || "",
        ]),
        flat: true,
        moneyCols: [3, 4, 6, 8],
        bestRows: data.map((_, i) => i === 0),
      });
    }

    if (!sections.length) {
      toast.error("No data available to export");
      return;
    }

    // ── Render ──────────────────────────────────────────────────────
    const maxCols = Math.max(
      1,
      ...sections.map((s) =>
        s.grouped
          ? Math.max(
              s.staticCols + s.groupHeaders.length * s.groupSpan,
              s.subHeaders.length,
            )
          : s.headers.length,
      ),
    );

    let rowIdx = 1;

    // Title band
    setCell(
      rowIdx,
      1,
      `TECHNO COMMERCIAL COMPARISON${rfxNr ? `  |  ${rfxNr}` : ""}`,
      f(true, P.titleFont, 16),
      P.titleFill,
      { horizontal: "center", vertical: "middle" },
    );
    worksheet.mergeCells(rowIdx, 1, rowIdx, maxCols);
    styleRange(rowIdx, 1, rowIdx, maxCols, f(true, P.titleFont, 16), P.titleFill, {
      horizontal: "center",
      vertical: "middle",
    });
    rowIdx++;

    sections.forEach((sec) => {
      // Section title band
      setCell(rowIdx, 1, sec.title, f(true, P.sectionFont, 13), P.sectionFill, {
        horizontal: "left",
        vertical: "middle",
      });
      worksheet.mergeCells(rowIdx, 1, rowIdx, maxCols);
      styleRange(rowIdx, 1, rowIdx, maxCols, f(true, P.sectionFont, 13), P.sectionFill, {
        horizontal: "left",
        vertical: "middle",
      });
      rowIdx++;

      if (sec.grouped) {
        // Group header row (merged supplier bands, L1 highlighted green)
        setCell(rowIdx, 1, "", f(true), P.groupFill, {
          horizontal: "center",
          vertical: "middle",
        });
        worksheet.mergeCells(rowIdx, 1, rowIdx, sec.staticCols);
        styleRange(rowIdx, 1, rowIdx, sec.staticCols, f(true), P.groupFill, {
          horizontal: "center",
          vertical: "middle",
        });
        sec.groupHeaders.forEach((label, gi) => {
          const c0 = sec.staticCols + gi * sec.groupSpan + 1;
          const c1 = c0 + sec.groupSpan - 1;
          const isBest = sec.groupBest[gi];
          worksheet.getCell(rowIdx, c0).value = label;
          worksheet.mergeCells(rowIdx, c0, rowIdx, c1);
          styleRange(
            rowIdx,
            c0,
            rowIdx,
            c1,
            f(true, isBest ? P.l1Font : P.groupFont, 12),
            isBest ? P.l1Fill : P.groupFill,
            { horizontal: "center", vertical: "middle", wrapText: true },
          );
        });
        rowIdx++;

        // Sub-header row
        sec.subHeaders.forEach((h, ci) => {
          setCell(rowIdx, ci + 1, h, f(true, P.headerFont, 11), P.headerFill, {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          });
        });
        rowIdx++;

        // Data rows with banding + money formatting
        sec.dataRows.forEach((row, ri) => {
          const band = ri % 2 === 1;
          row.forEach((v, ci) => {
            const inGroup = ci >= sec.staticCols;
            const localOffset = inGroup
              ? (ci - sec.staticCols - 1) % sec.groupSpan
              : -1;
            const isMoney = sec.moneyOffsets?.includes(localOffset);
            const cell = setCell(rowIdx, ci + 1, v, f(false), band ? P.bandFill : null, {
              wrapText: true,
              vertical: "middle",
            });
            if (isMoney && typeof v === "number") cell.numFmt = "#,##0.00";
          });
          rowIdx++;
        });

        // Total row (best value highlighted green)
        if (sec.totalRow) {
          sec.totalRow.forEach((v, ci) => {
            const isBestCell = ci + 1 === sec.totalBestScoreCol;
            const inGroup = ci >= sec.staticCols;
            const localOffset = inGroup
              ? (ci - sec.staticCols - 1) % sec.groupSpan
              : -1;
            const isMoney = sec.moneyOffsets?.includes(localOffset);
            const cell = setCell(
              rowIdx,
              ci + 1,
              v,
              f(true, isBestCell ? P.bestFont : P.totalFont, 11),
              isBestCell ? P.bestFill : P.totalFill,
              { horizontal: isBestCell ? "center" : "left", vertical: "middle" },
            );
            if (isMoney && typeof v === "number") cell.numFmt = "#,##0.00";
          });
          rowIdx++;
        }
      } else {
        // Header row
        sec.headers.forEach((h, ci) => {
          setCell(rowIdx, ci + 1, h, f(true, P.headerFont, 11), P.headerFill, {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          });
        });
        rowIdx++;

        // Data rows with banding + best-row highlight
        sec.rows.forEach((row, ri) => {
          const isBest = sec.bestRows?.[ri];
          const isBoldRow = sec.boldRows?.includes(ri);
          const band = ri % 2 === 1;
          row.forEach((v, ci) => {
            const isMoney = sec.moneyCols?.includes(ci);
            const cell = setCell(
              rowIdx,
              ci + 1,
              v,
              f(
                isBest || isBoldRow,
                isBest ? P.bestFont : isBoldRow ? P.totalFont : "FF000000",
                11,
              ),
              isBest
                ? P.bestFill
                : isBoldRow
                  ? P.totalFill
                  : band
                    ? P.bandFill
                    : null,
              { wrapText: true, vertical: "middle" },
            );
            if (isMoney && typeof v === "number") cell.numFmt = "#,##0.00";
          });
          rowIdx++;
        });
      }

      rowIdx++; // spacer after each section
    });

    // Auto-fit column widths (capped)
    worksheet.columns.forEach((col) => {
      if (!col) return;
      let maxLen = 0;
      (col.values || []).forEach((v) => {
        const len = String(v ?? "").length;
        if (len > maxLen) maxLen = len;
      });
      col.width = Math.min(Math.max(maxLen + 3, 10), 55);
    });

    // Keep the title band visible while scrolling
    worksheet.views = [{ state: "frozen", ySplit: 1 }];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Techno_Commercial_Comparison_${rfxNr || "RFQ"}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          {/* <Loader isLoading={loading} className={"text-center"} /> */}
        </Col>
        {/* {!loading && ( */}
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Commercial Evaluation for
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {formInputs?.rfxNr}
              </span>
              <span>
                {formInputs?.rfxHeaderStatus === "Published" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.rfxHeaderStatus}
                  </span>
                ) : formInputs?.rfxHeaderStatus === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.rfxHeaderStatus}
                  </span>
                ) : formInputs?.rfxHeaderStatus === "Commercial Approved" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.rfxHeaderStatus}
                  </span>
                ) : formInputs?.rfxHeaderStatus === "Commercial Open" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.rfxHeaderStatus}
                  </span>
                ) : formInputs?.rfxHeaderStatus ===
                  "Commercial Pending with L1" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.rfxHeaderStatus}
                  </span>
                ) : formInputs?.rfxHeaderStatus ===
                  "Commercial Pending with L2" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.rfxHeaderStatus}
                  </span>
                ) : (
                  formInputs?.rfxHeaderStatus
                )}
              </span>
            </h2>
            <p className="subText">Commercial Evaluation Details</p>
            <hr />

            {/* Workflow Component */}
            <WorkflowApproveReject
              workflowData={workflow}
              formInputsData={formInputs}
            />

            {workflowConfig?.showInDetailPage &&
              formInputs?.workflowActionLogs?.length > 0 && (
                <ShowHorizontalStatus
                  rowdatamodal={formInputs?.workflowActionLogs}
                />
              )}

            {/*RFQ Type  */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RT</span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <span className="headerTitle">RFQ Details </span>
                      <span className="subHeaderTitle">
                        RFQ Type Information
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="RFQ ID"
                          name="rfxNr"
                          // placeholder=""
                          value={formInputs?.rfxNr || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="RFQ Version"
                          name="firstName"
                          placeholder=""
                          value={formInputs?.rfxVersion || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Title"
                          name="UnitPrice"
                          // placeholder=""
                          value={formInputs?.rfxTitle || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Description"
                          name="UnitPrice"
                          // placeholder=""
                          value={formInputs?.rfxDescription || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="RFQ Category"
                          name="UnitPrice"
                          // placeholder=""
                          value={formInputs?.rfxCategoryDesc || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="RFQ Type"
                          name="UnitPrice"
                          // placeholder=""
                          value={formInputs?.rfxTypeDesc || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Number Of Evaluation"
                          name="UnitPrice"
                          // placeholder=""
                          value={formInputs?.rfxNoOfEvaluationTypeDesc || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product Type"
                          name="firstName"
                          placeholder=""
                          value={formInputs?.productTypeDesc || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Buyer Contact"
                          name="buyerConact"
                          // placeholder=""
                          value={matchObj?.buyerConact || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Buyer Responsible"
                          name="UnitPrice"
                          // placeholder=""
                          value={formInputs?.initiatorName || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Billing Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.billingAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Address"
                          name="companyAddress"
                          placeholder=""
                          value={formInputs?.companyAddress || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivery Address"
                          name="billingAddressDesc"
                          placeholder=""
                          value={formInputs?.billingAddressDesc || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="INCOTerms"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.INCOTermslocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="INCOTerms Location"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.INCOTermslocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col> */}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Header Info */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HI</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">
                        Commercial Evaluation Details
                      </span>
                      <span className="subHeaderTitle">
                        Commercial Evaluation Information
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Tech Evaluation Started On"
                            type="date"
                            name="techEvaluationStartedOn"
                            value={
                              formInputs?.techEvaluationStartedOn ||
                              getCurrentDate("")
                            }
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Tech Evaluation Prepared On "
                            name="techEvaluationPreparedOn "
                            type="date"
                            value={
                              formInputs?.techEvaluationPreparedOn ||
                              getCurrentDate("")
                            }
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Comm Focal Point"
                          placeholder=""
                          data={getTechnicalUserList}
                          id="rfxTechFocalPersonId"
                          name="rfxTechFocalPersonId"
                          code="rfxTechFocalPersonIdCode"
                          description="rfxTechFocalPersonIdDesc"
                          iconClassName="dropdownIcon"
                          setValue={matchObj?.rfxTechFocalPersonId || ""}
                          getvalue={setDropdownData}
                          disabled={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Comm Focal Point"
                          placeholder=""
                          data={getTechnicalUserList}
                          id="rfxTechFocalPersonId"
                          name="rfxTechFocalPersonId"
                          code="rfxTechFocalPersonIdCode"
                          description="rfxTechFocalPersonIdDesc"
                          iconClassName="dropdownIcon"
                          setValue={
                            formInputs?.rfxTechFocalPersonId ||
                            getTechnicalEvalHeaderData?.rfxTechFocalPersonId
                          }
                          getvalue={setDropdownData}
                          disabled={getDisabledStatus}
                        />
                      </Col> */}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label=" Technical Approval Type"
                          name="firstName"
                          placeholder=""
                          value={formInputs?.technicalApprovalType || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Eligibility Score"
                          name="firstName"
                          placeholder=""
                          value={
                            sourcingConfig?.rfxControlData?.eligibilityScore
                          }
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Technical Evaluator"
                          name="technicalEvaluator"
                          placeholder=""
                          value={matchObj?.technicalEvaluator || ""}
                          // value={
                          //   sourcingConfig?.rfxControlData?.eligibilityScore
                          // }
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Evaluator Comments"
                          name="evaluatorComments"
                          value={formInputs?.evaluatorComments || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Evaluator Supplier Clarification"
                          name="evaluatorSupplierClarification"
                          value={
                            formInputs?.evaluatorSupplierClarification || ""
                          }
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Upload Tech Eval Report Attachments"
                          name="uploadTechEvalReportAttachments"
                          value={
                            formInputs?.uploadTechEvalReportAttachments || ""
                          }
                          onChange={onInputChange}
                          disabled={true}
                        />
                        <div className="col-sm-10">
                          <input
                            className="form-control"
                            type="file"
                            id="formFile"
                            disabled={true}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Instructions 10*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible10
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility10}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RE</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Instructions</span>
                      <span className="subHeaderTitle">
                        Instructions Section
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible10 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="p-4">
                      <Col xs={12} md={12} lg={12}>
                        <RichTextEditor
                          value={formInputs?.instructions}
                          readOnly={true}
                          onChange={handleEditorChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Instructions 10*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible15
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility15}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RE</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        Commercial Justification Memo
                      </span>
                      <span className="subHeaderTitle">
                        Commercial Justification Memo
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible15 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="p-4">
                      <Col xs={12} md={12} lg={12}>
                        <RichTextEditor
                          value={formInputs?.instructionsJustificationMemo}
                          readOnly={true}
                          onChange={handleEditorChangeInstuctions}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* 5 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SD</span>
                    </Col>
                    <Col xs={12} md={6} lg={7}>
                      <span className="headerTitle">Suppliers</span>
                      <span className="subHeaderTitle">
                        Selected Suppliers Details
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={suppliersColumns}
                          data={formInputs?.supplierList}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Evaluation Criteria 12 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible12
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility12}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">EC</span>
                    </Col>
                    <Col xs={9} md={5} lg={6}>
                      <span className="headerTitle">Evaluation Criteria</span>
                      <span className="subHeaderTitle">
                        Evaluation Criteria Details
                      </span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-end">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>

                          <li onClick={handleExportEvalCriteria}>
                            <span className="dropdown-item headerIcon">
                              <i className="bi bi-download mr-2"></i>
                              Download Xl
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible12 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={evaluationCriteriaColumns}
                          data={getEvaluationCriteria}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Exchange rate 13 */}
            {/* <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible13
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility13}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">ER</span>
                      </Col>
                      <Col xs={12} md={6} lg={7}>
                        <span className="headerTitle">Exchange Rate</span>
                        <span className="subHeaderTitle">
                          Exchange Rate Details
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible13 ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // title=""
                            columns={exchangeRateColumns}
                            data={getExchangeRateData}
                            // progressPending={loading}
                            // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                            // pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div> */}

            {/* Commercial Evaluation 08*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CE</span>
                    </Col>

                    <Col xs={3} md={7} lg={6}>
                      <span className="headerTitle">
                        Commercial Evaluation Questions
                      </span>
                    </Col>
                    {/* <Col xs={1} md={1} lg={1} className="text-end">
                      <button
                        className="btn btn-sm"
                        onClick={handleExportCommEvalQuestions}
                        title="Download Excel"
                      >
                        <i className="bi bi-download"></i>
                      </button>
                    </Col> */}
                    <Col xs={1} md={1} lg={1} className="text-end">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>

                          <li onClick={handleExportCommEvalQuestions}>
                            <span className="dropdown-item headerIcon">
                              <i className="bi bi-download mr-2"></i>
                              Download Xl
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body autoScroll">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <EvaluationTable
                          data={techData}
                          sendDataToParent={handleEvaluationTableData}
                          pageStatus={getDisabledStatus}
                          technicalWeight={commercialTotalWeight}
                          disabledQuotationNrs={failedQuotationNrs}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Techno Commercial Comparison 16 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible16 ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility16}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TC</span>
                    </Col>
                    <Col xs={3} md={7} lg={6}>
                      <span className="headerTitle">
                        Techno Commercial Comparison
                      </span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-end">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li onClick={handleExportAll}>
                            <span className="dropdown-item headerIcon">
                              <i className="bi bi-download mr-2"></i>
                              Download Xl
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible16 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body autoScroll">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <TechnoCommercialComparison
                          questions={formInputs?.rfxQuestions || []}
                          techWeight={Number(matchObj?.technicalTotalWeight ?? formInputs?.technicalTotalWeight) || 0}
                          commWeight={commercialTotalWeight}
                          pageStatus={getDisabledStatus}
                          disabledQuotationNrs={failedQuotationNrs}
                          onDownload={handleExportAll}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Commercial Evaluation Summary 11 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible11
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility11}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CE</span>
                    </Col>
                    <Col xs={9} md={5} lg={6}>
                      <span className="headerTitle">
                        Commercial Evaluation Summary
                      </span>
                      <span className="subHeaderTitle">
                        Commercial Evaluation Summary Details
                      </span>
                    </Col>
                    {/* <Col xs={1} md={1} lg={1} className="text-end">
                      <button
                        className="btn btn-sm"
                        onClick={handleExportCommEvalSummary}
                        title="Download Excel"
                      >
                        <i className="bi bi-download"></i>
                      </button>
                    </Col> */}
                    <Col xs={1} md={1} lg={1} className="text-end">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>

                          <li onClick={handleExportCommEvalSummary}>
                            <span className="dropdown-item headerIcon">
                              <i className="bi bi-download mr-2"></i>
                              Download Xl
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible11 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={CommEvaluationSumColumns}
                          data={getSupplierList}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Line Item 09*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible9
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility9}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>

                    <Col xs={3} md={7} lg={6}>
                      <span className="headerTitle">Line Item</span>
                    </Col>
                    {/* <Col xs={1} md={1} lg={1} className="text-end">
                      <button
                        className="btn btn-sm"
                        onClick={handleExportLineItems}
                        title="Download Excel"
                      >
                        <i className="bi bi-download"></i>
                      </button>
                    </Col> */}
                    <Col xs={1} md={1} lg={1} className="text-end">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>

                          <li onClick={handleExportLineItems}>
                            <span className="dropdown-item headerIcon">
                              <i className="bi bi-download mr-2"></i>
                              Download Xl
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible9 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body autoScroll">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <CommLineItemTable
                          data={lineItemData}
                          sendDataToParent={handleItemData}
                          pageStatus={getDisabledStatus}
                          disabledQuotationNrs={failedQuotationNrs}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Award Summary 14*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible14
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility14}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AS</span>
                    </Col>

                    <Col xs={3} md={7} lg={6}>
                      <span className="headerTitle">Award Summary</span>
                    </Col>
                    {/* <Col xs={1} md={1} lg={1} className="text-end">
                      <button
                        className="btn btn-sm"
                        onClick={handleExportAwardSummary}
                        title="Download Excel"
                      >
                        <i className="bi bi-download"></i>
                      </button>
                    </Col> */}
                    <Col xs={1} md={1} lg={1} className="text-end">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>

                          <li onClick={handleExportAwardSummary}>
                            <span className="dropdown-item headerIcon">
                              <i className="bi bi-download mr-2"></i>
                              Download Xl
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible14 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body autoScroll">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={CommAwardSummaryColumns}
                          data={getSupplierList}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            <div className="pageFooter pb-2">
              <Row className="rowDirection">
                <Col xs={12} md={3} lg={3} className="">
                  <button className="btnTable" onClick={handleExportAll}>
                    <i className="bi bi-download mr-2"></i>
                    Techno commercial comparison{" "}
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default CommercialEvaluationDetails;
